module.exports = __webpack_public_path__ + "img/association-institution-3.c5c1937d.png";